export default "__VITE_PUBLIC_ASSET__5c9c0010__"